import * as z from 'zod/mini';
import { defineFormInput } from './defineFormInput.js';
/**
 * Schema for multi-select form input.
 */
export const MultiSelectInput = defineFormInput({
    type: 'MULTI_SELECT',
    input: {
        question: z.string().check(z.describe(`Question to display to the user. Ask about single thing. Do not repeat options here:            
[BAD]
Do you have other symptoms (nausea, diarrhea, etc.)? 
[GOOD]
Do you have other symptoms?`)),
        help: z
            .optional(z.string())
            .check(z.describe('Help text to display to the user. Use it when you need to provide more context about the question, explain the reason or provide explanation for medical terms.')),
        options: z
            .array(z.string())
            .check(z.describe('Options to choose from. Never include "none", or "other" option here. Only provide options that make sense to select simultaneously. Provide between 6 and 10 options.')),
        customOption: z.string().check(z.describe('Label for the "add custom option" button. ')),
        noneOption: z
            .optional(z.string())
            .check(z.describe('Label for the "none" option. If not provided, the input will not have a "none" option.')),
    },
    description: 'Ask the user to one or more options from a list. They can also provide their custom options.',
    value: {
        options: z.array(z.string()),
    },
});
//# sourceMappingURL=MultiSelectInput.js.map